import customAxios from "./axiosConfig";

const GekkoProduct = {
  list (params) {
    const api_url = window.Urls['gekkoproduct-list']()
    return customAxios.get(api_url, { params: params });
  }
};

export default GekkoProduct;